import { moduleNames } from '@va/constants';
import { VisaNestedPageNavigation } from '@va/dashboard/components';
import { isModuleEnabled } from '@va/dashboard/selectors/app';
import { PageHeader, TitleAndContextMenu } from '@va/dashboard/shared/ui-layout';
import { useTranslate } from '@va/localization';
import { buildNestedNavigation, buildNestedRoute } from '@va/util/helpers';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { LatestVisitorsTab } from './latestVisitors';
import { LocationsTab } from './locations';
import { TrafficChartsTab } from './traffic-charts';
import { MapTab } from './visitorsMap';
import { VisitsByCompanyOverview } from './visits-by-company';

export const VisitorsTab = () => {
  const translate = useTranslate();
  const isEnabled = useSelector(isModuleEnabled);

  const routes = useMemo(
    () =>
      buildNestedNavigation([
        buildNestedRoute({
          link: '/latest',
          label: translate('all.latestVisitors.latestVisitors.title'),
          tooltip: 'tooltipTab.latest',
          component: LatestVisitorsTab,
          shouldDisplay: isEnabled(moduleNames.visitorsOverview),
        }),
        buildNestedRoute({
          link: '/map',
          label: translate('all.latestVisitors.map.title'),
          tooltip: 'tooltipTab.map',
          component: MapTab,
          shouldDisplay: isEnabled(moduleNames.visitorsMap),
        }),
        buildNestedRoute({
          link: '/charts',
          label: translate('all.latestVisitors.traffic.title'),
          tooltip: 'tooltipTab.traffic',
          component: TrafficChartsTab,
          shouldDisplay: isEnabled(moduleNames.visitorsCharts),
        }),
        buildNestedRoute({
          link: '/locations',
          label: translate('all.latestVisitors.locations.title'),
          tooltip: 'tooltipTab.locations',
          component: LocationsTab,
          shouldDisplay: isEnabled(moduleNames.visitorsLocation),
        }),
        buildNestedRoute({
          link: '/company-visits',
          label: translate('all.latestVisitors.companyVisits.title'),
          tooltip: 'tooltipTab.companyVisits',
          component: VisitsByCompanyOverview,
          shouldDisplay: isEnabled(moduleNames.visitorsCompanyDistribution),
        }),
      ]),
    [isEnabled, translate],
  );

  return (
    <>
      <PageHeader
        title={
          <TitleAndContextMenu
            title={translate('all.latestVisitors.title')}
            tooltipTransKey='tooltipTab.latestVisitors'
          />
        }
        hideBorder
      />
      <VisaNestedPageNavigation routes={routes} />
    </>
  );
};
